import { node } from "~/util/dom";

interface ICreateStars {
	rating: number;
	gap?: number;
	size?: number;
	disabled?: boolean;
}

function createStars({
	rating,
	gap = 0,
	size = 32,
	disabled = false,
}: ICreateStars) {
	const starsBanner = node("mapy-review-stars");

	starsBanner.disabled = disabled;
	starsBanner.setAttribute("size", size.toString());
	starsBanner.setAttribute("gap", gap.toString());
	starsBanner.setAttribute("value", ((rating / 100) * 5).toString());

	return starsBanner;
}

// 16px sirka, 2px mezera, def. bez interakce
export function createSmallStars({
	rating,
	disabled = true,
}: Pick<ICreateStars, "rating" | "disabled">) {
	return createStars({
		rating,
		gap: 2,
		size: 16,
		disabled,
	});
}
